
export class Reponse {
       id_reponse:any;
       contenu_reponse:any;
       responsable:any;
       date_reponse : Date;
       etat_reponse:any;
       id_mess:any;
       fichier_reponse:any;
       
       
    constructor(id_reponse:any){
           
    }
}
